import { render, staticRenderFns } from "./Exercise2.vue?vue&type=template&id=69458eb5&"
import script from "./Exercise2.vue?vue&type=script&lang=js&"
export * from "./Exercise2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports